export enum StepName {
  store = 'store',
  material = 'material',
  color = 'color',
  designShape = 'designShape',
  designEdge = 'designEdge',
  designCornerRadius = 'designCornerRadius',
  designDiagonalCorner = 'designDiagonalCorner',
  designCustomSide = 'designCustomSide',
  designSink = 'designSink',
  designCookingAppliance = 'designCookingAppliance',
  designCutout = 'designCutout',
  designTearOut = 'designTearOut',
  designAddOn = 'designAddOn',
  orderSummary = 'orderSummary',
}

export type RequiredStepName =
  | StepName.store
  | StepName.material
  | StepName.color
  | StepName.designShape
  | StepName.orderSummary;

export type DesignStepName =
  | StepName.designShape
  | StepName.designEdge
  | StepName.designCornerRadius
  | StepName.designDiagonalCorner
  | StepName.designCustomSide
  | StepName.designSink
  | StepName.designCookingAppliance
  | StepName.designCutout
  | StepName.designTearOut
  | StepName.designAddOn;
